import React from 'react'

import { useTranslation } from '../../translations/useTranslation'

interface Props {
    value: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
}

export const LoginDevInput: React.FC<Props> = ({ value, onChange, onBlur }) => {

    const { t, keys } = useTranslation()

    return (
        <div className="membership-app__login-input">
            <label htmlFor="personalIdNumber">
                <span id="membership-app__login-input-labelId" className="membership-app__login-input-text">{t(keys.uiPersonalIdNumber)}</span>
                <input
                    id="personalIdNumber"
                    name="personalIdNumber"
                    type="text"
                    value={value}
                    autoCorrect="off"
                    pattern="[0-9]*"
                    onChange={onChange}
                    onBlur={onBlur}
                    tabIndex={0}
                    autoFocus
                    aria-label="membership-app__login-input-labelId"
                />
                <img alt="" src="https://a.klarnacdn.net/klapp/assets/web/f805fef7f2c2197a13246b334f39b8fa.svg"></img>
            </label>

        </div>
    )
}